<div
  [ngClass]="allReports ? 'justify-center gap-4' : 'justify-center'"
  class="relative flex w-full items-center justify-center gap-4"
>
  <mat-button-toggle-group
    [(value)]="selectedTimeMode"
    [multiple]="false"
  >
    <mat-button-toggle [value]="selectedTimeReportType.DAY">
      {{ 'time-period-selector.day' | translate }}
    </mat-button-toggle>
    <mat-button-toggle [value]="selectedTimeReportType.WEEK">
      {{ 'time-period-selector.week' | translate }}
    </mat-button-toggle>
    <mat-button-toggle [value]="selectedTimeReportType.MONTH">
      {{ 'time-period-selector.month' | translate }}
    </mat-button-toggle>
    <mat-button-toggle [value]="selectedTimeReportType.YEAR">
      {{ 'time-period-selector.year' | translate }}
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
